var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8529 56.9814C44.8632 56.7431 43.8245 56.6209 42.8836 56.2482C39.7616 55.0141 37.6415 52.7535 36.7679 49.5093C35.6559 45.3852 36.7495 41.805 39.9388 38.9701C42.2604 36.9112 45.0403 36.1169 48.1196 36.5996C51.8098 37.18 54.4859 39.2206 55.9827 42.6237C57.4979 46.0756 57.1313 49.4604 55.0052 52.5763C53.4533 54.8491 51.2661 56.2299 48.5656 56.7859C48.1685 56.8653 47.7714 56.9142 47.3742 56.9814H45.8529ZM53.8321 46.7416C53.8443 42.7764 50.6001 39.5139 46.6227 39.5078C42.6637 39.5016 39.4256 42.7214 39.395 46.6866C39.3645 50.6518 42.6026 53.9204 46.5861 53.9388C50.5512 53.9632 53.8138 50.719 53.8321 46.7416Z",
    fill: "#1E8FCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8455 41.6648V44.6524H29.8396V41.6648H32.8455Z",
    fill: "#1E8FCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7601 50.7313H23.7664V47.7375H26.7601V50.7313Z",
    fill: "#1E8FCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9685 25.1443C18.1396 24.3622 18.3717 23.6047 18.8727 22.957C19.7709 21.7962 20.9561 21.173 22.4224 21.118C23.0517 21.0936 23.681 21.118 24.3409 21.118V18.106H27.3896V21.0997H47.4415V18.0999H50.4719V21.118C51.1256 21.118 51.7427 21.1058 52.3597 21.118C53.9055 21.1608 55.1396 21.8084 56.0439 23.0609C56.5632 23.7757 56.8626 24.5883 56.8626 25.4681C56.8809 29.6715 56.8748 33.875 56.8748 38.0845C56.8748 38.109 56.8626 38.1334 56.8442 38.1945C56.7648 38.1212 56.6976 38.0601 56.6304 37.999C55.7934 37.2536 54.9563 36.496 54.1071 35.769C53.9299 35.6162 53.8322 35.4879 53.8322 35.2374C53.8505 34.3027 53.8383 33.3618 53.8383 32.3964H21.005V32.7936C21.005 39.2515 21.005 45.7094 21.005 52.1673C21.005 53.3587 21.5915 53.9452 22.7707 53.9452C26.8764 53.9452 30.976 53.9452 35.0816 53.9452C35.3505 53.9452 35.4971 54.0429 35.6743 54.2446C36.383 55.0816 37.1284 55.8942 37.8554 56.7129C37.9349 56.8045 38.0204 56.8962 38.1059 56.9878H21.9948C21.9337 56.9634 21.8787 56.9328 21.8176 56.9267C20.559 56.7251 19.5692 56.0897 18.8177 55.0755C18.3473 54.4462 18.1335 53.713 17.9685 52.9615V25.1443ZM47.4598 24.1851H27.3835V27.1727H24.3409V24.1545C23.7299 24.1545 23.1617 24.1484 22.5935 24.1545C21.6526 24.1667 21.0233 24.796 21.0172 25.7369C21.005 26.635 21.0172 27.5332 21.0172 28.4313C21.0172 28.7184 21.0172 29.0056 21.0172 29.2927H53.8383C53.8383 28.0403 53.8566 26.8122 53.8322 25.5842C53.82 24.8632 53.2762 24.2523 52.5675 24.1851C51.8954 24.124 51.2111 24.1728 50.4902 24.1728V27.1727H47.472V24.179L47.4598 24.1851Z",
    fill: "#1E8FCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7726 35.5613H26.7542V38.5672H23.7726V35.5613Z",
    fill: "#1E8FCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8518 35.5857V38.5672H29.8458V35.5857H32.8518Z",
    fill: "#1E8FCF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9245 35.5796V38.5672H35.9307V35.5796H38.9245Z",
    fill: "#1E8FCF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7726 41.6523H26.7664V44.6461H23.7726V41.6523Z",
    fill: "#1E8FCF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8396 50.7254V47.7317H32.8333V50.7254H29.8396Z",
    fill: "#1E8FCF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0466 41.6523H48.0525V45.1898H50.6247V48.2263H45.0527V41.6523H45.0466Z",
    fill: "#1E8FCF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.131348,
    width: 74.8687,
    height: 74.8687,
    rx: 10,
    fill: "#1E8FCF",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCalendar);
export default __webpack_public_path__ + "static/media/report_calendar.9d622875934a667dda88832f25d493d3.svg";
export { ForwardRef as ReactComponent };